import { Controller } from "@hotwired/stimulus"

// Hides its element and remembers the dismissal in sessionStorage, so a
// dismissed banner stays hidden for the rest of the browser session but
// returns on the next one (a gentle, non-permanent nudge).
export default class extends Controller {
  static values = { key: String }

  connect() {
    if (this.dismissed) this.element.hidden = true
  }

  dismiss() {
    if (this.hasKeyValue) sessionStorage.setItem(this.storageKey, "1")
    this.element.hidden = true
  }

  get dismissed() {
    return this.hasKeyValue && sessionStorage.getItem(this.storageKey) === "1"
  }

  get storageKey() {
    return `dismissed:${this.keyValue}`
  }
}
